<template>
  <div>
    <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/26/94/rB8LrWWDydWAGSG9AAVhXhKCBjI150.png" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="stylus" scoped>
  img {
    width: 375px;
    height: 230px;
  }
</style>